import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const SettingsChangePassStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  logo: {
    margin           : "1rem 0",
    "& img"          : {
      width   : "25%",
      display : "block",
      margin  : "auto"
    },
    "& span"          : {
      width        : "100px",
      height       : "1px",
      borderBottom : "3px solid " + ts_main[3],
      display      : "block",
      margin       : "1rem auto"
    }
  },
  //---------
  //TextField
  //---------
  textField1: {
    marginTop    : 10,
    marginBottom : 10,
    input        : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  textField2: {
    marginTop    : 40,
    marginBottom : 10,
    input        : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  textField3: {
    marginTop    : 10,
    marginBottom : 10,
    input        : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 0,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
});

export default SettingsChangePassStyle;
